"use client";

import { motion } from "motion/react";
import { slideUpVariants, fadeInVariants } from "@/lib/animations";
import type { BeyondCardBg, BeyondCardProps } from "../types";

export function BeyondCard({
  title,
  description,
  bg,
  width = "medium",
}: BeyondCardProps) {
  const widthClasses = {
    large: "sm:w-[60%]",
    small: "sm:w-[40%]",
    medium: "sm:w-[55%]",
  };

  const bgClasses: Record<BeyondCardBg, string> = {
    "beyond-1": "bg-beyond-1",
    "beyond-2": "bg-beyond-2",
    "beyond-3": "bg-beyond-3",
    "beyond-4": "bg-beyond-4",
    "beyond-5": "bg-beyond-5",
  };

  return (
    <motion.div
      className={`h-60 overflow-hidden rounded-3xl bg-cover bg-center lg:h-[354px] ${widthClasses[width]} ${bgClasses[bg]}`}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, amount: 0.3 }}
      variants={fadeInVariants}
    >
      <div className="flex h-full w-full flex-col justify-end bg-beyond-card-gradient p-5 text-white lg:p-6">
        <motion.h3
          className="tracking-copy text-2xl font-medium"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          variants={slideUpVariants}
        >
          {title}
        </motion.h3>
        <motion.p
          className="mt-1 max-w-60 text-sm tracking-[-0.01em] md:max-w-72 lg:text-base"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          variants={slideUpVariants}
        >
          {description}
        </motion.p>
      </div>
    </motion.div>
  );
}
